import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import './items-per-page.scss';

applyTranslations(require('./items-per-page.i18n.json'));

interface Props {
  perPage: number,
  onChange: (i: number) => void
}

const ItemsPerPage = ({ perPage, onChange }: Props): JSX.Element => {
  const perPageValue = [10, 50, 100].some(v => v === perPage) ? perPage : 10;
  const getSelectedPerPageValueClasses = (selected: boolean): string => (
    classnames({
      'items-per-page__item-value': true,
      'items-per-page__item-value--selected': selected
    })
  );

  return (
    <div className="items-per-page">
      <span className="items-per-page__label">
        {__t('items_per_page.collections_per_page_label')}
      </span>
      <div>
        <span
          className="items-per-page__item"
          onClick={() => onChange(10)}
        >
          <span
            className={getSelectedPerPageValueClasses(perPageValue === 10)}
          >
            10
          </span>
        </span>
        <span
          className="items-per-page__item"
          onClick={() => onChange(50)}
        >
          <span
            className={getSelectedPerPageValueClasses(perPageValue === 50)}
          >
            50
          </span>
        </span>
        <span
          className="items-per-page__item"
          onClick={() => onChange(100)}
        >
          <span
            className={getSelectedPerPageValueClasses(perPageValue === 100)}
          >
            100
          </span>
        </span>
      </div>
    </div>
  );
};

export default ItemsPerPage;
